import React from 'react';
import { useClassName, useWindowSize } from 'common/hooks';
import './enhance-header.less';
import { AnimatedText } from '../../AnimatedText/AnimatedText';

export const EnhanceHeader = ({ title, description, petImage }) => {
  const className = useClassName('EnhanceHeader');
  const { isTablet, isDesktop } = useWindowSize();

  const headerStyles = {};

  if (petImage.styles['z-index']) {
    headerStyles['z-index'] = petImage.styles['z-index'];
  }

  return (
    <div className={className('container')} style={headerStyles}>
      <h3 className={className('title')}>
        <AnimatedText text={title} />
      </h3>
      <p className={className('description')}>{description}</p>
      <div className={className('pet-image')} style={petImage.styles || {}}>
        <img
          src={
            petImage.source[
              isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile'
            ]?.assetUrl
          }
          alt={
            petImage.source[
              isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile'
            ]?.assetAlt
          }
        />
      </div>
    </div>
  );
};
